module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ed-Fb-Gc.1e5f5122.png";